import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, of } from 'rxjs'
import { catchError, map, retry } from 'rxjs/operators'
import { IEtaGuide, IEtaGuideTable } from '../models/interface/eta-guide.interface'
import { SharedService } from './shared/shared.service'
import { AppConfigurationService } from './app-configuration.service'

@Injectable({
  providedIn: 'root'
})
export class EtaService {
  public deliveryEtaGuide: IEtaGuide

  constructor(
    private http: HttpClient,
    private appConfigurationService: AppConfigurationService,
    private sharedService: SharedService
  ) {}

  public getDeliveryEtaGuide(): Observable<IEtaGuide> {
    if (this.deliveryEtaGuide) {
      return of(this.deliveryEtaGuide)
    }

    const url = `${this.appConfigurationService.getBaseSiteUrl()}/basestores/${this.sharedService.baseSiteId}`
    return this.http.get<any>(url).pipe(
      map((res) => {
        this.deliveryEtaGuide = {
          list: res?.deliveryEtaGuidance,
          table: this.convertDataIntoTable(res?.deliveryEtaGuidance)
        }
        return this.deliveryEtaGuide
      }),
      catchError(() => of(this.deliveryEtaGuide)),
      retry(1)
    )
  }

  private convertDataIntoTable(etaGuide): IEtaGuideTable {
    if (!etaGuide) {
      return {}
    }

    let rowCount = 0
    const colCount = etaGuide.length
    const header = []
    const body = []

    etaGuide = etaGuide.map((item) => {
      header.push(item.key)

      const arr = item.value ? item.value?.split(',') : []
      if (rowCount < arr?.length) {
        rowCount = arr.length
      }

      return {
        ...item,
        value: arr
      }
    })

    for (let i = 0; i < rowCount; i++) {
      for (let j = 0; j < colCount; j++) {
        if (!body[i]) {
          body[i] = []
        }
        body[i].push(etaGuide[j].value[i])
      }
    }

    return {
      keys: header,
      values: body
    }
  }
}
